var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { API_ANNOUNCEMENTS, API_URL_ANNOUNCEMENT } from ".";
export const getAnnouncements = (api, domain) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_ANNOUNCEMENTS + domain);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("announcements not found");
            }
        }
        throw new Error("server error");
    }
});
export const addAnnouncementItem = (api, domain, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.post(API_ANNOUNCEMENTS + domain, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("announcement not found");
            }
            if (serverResponse && serverResponse.status === 400) {
                throw new Error("announcement already exists or invalid url setting id");
            }
        }
        throw new Error("server error");
    }
});
export const getAnnouncementItem = (api, urlSettingId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_URL_ANNOUNCEMENT + urlSettingId);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("announcement not found");
            }
        }
        throw new Error("server error");
    }
});
export const deleteAnnouncementItem = (api, urlSettingId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield api.delete(API_URL_ANNOUNCEMENT + urlSettingId);
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("announcement not found");
            }
        }
        throw new Error("server error");
    }
});
export const updateAnnouncementItem = (api, urlSettingId, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.put(API_URL_ANNOUNCEMENT + urlSettingId, data);
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const serverResponse = error.response;
            if (serverResponse && serverResponse.status === 404) {
                throw new Error("announcement not found");
            }
        }
        throw new Error("server error");
    }
});
//# sourceMappingURL=announcement.js.map